module.exports = __webpack_public_path__ + "media/images/gifts/sensations/sug_sensorial_7-4785ff7187460e1ce549e41cb9479ebb.jpg";